import { render, staticRenderFns } from "./BRELAG_MAGBattery.vue?vue&type=template&id=ac6c647a&"
import script from "./BRELAG_MAGBattery.vue?vue&type=script&lang=js&"
export * from "./BRELAG_MAGBattery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports